import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '../../Input';
import { useActives } from '../../../hooks/useActives';
import { AuthContext } from '../../../context/UserContext';
import { financeRoutes } from '../../../utils/RoutesApi';
import { handleToast } from '../../Toast';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Container } from './styles';
import { useActivesWallet } from '../../../jsx/pages/Wallet/hooks/ActivesHooks';

const INTERNATIONAL_TYPES = ['stock', 'stocks', 'reit', 'reits', 'etf', 'etfs'];

export function SimpleActive(props) {
  const { updateWallet } = useActivesWallet();
  var { setCancel, edit, update } = props;
  const { setPercentage, setActives } = useActives();
  const { register, handleSubmit, setValue } = useForm();
  const { user } = useContext(AuthContext);
  const [activeSelect, setActiveSelect] = useState('');
  const [selectValues, setSelectValues] = useState([]);
  const [typeActive, setTypeActive] = useState('');
  const [amountOrPrice, setAmountOrPrice] = useState();
  const [values, setValues] = useState([]);
  const [tradeDate, setTradeDate] = useState('');
  const [priceUsd, setPriceUsd] = useState('');
  const [priceTotal, setPriceTotal] = useState('');
  const [brokerOrigin, setBrokerOrigin] = useState('');

  const isInternational = INTERNATIONAL_TYPES.includes(typeActive);

  // Mantém a quantidade atual acessível dentro de efeitos sem recriá-los.
  const amountRef = useRef(amountOrPrice);
  amountRef.current = amountOrPrice;

  // Quantidade alterada → recalcula o valor total mantendo o preço unitário.
  function handleQuantityChange(value) {
    setAmountOrPrice(value);
    if (Number(value) > 0 && Number(priceUsd) > 0) {
      setPriceTotal((Number(value) * Number(priceUsd)).toFixed(2));
    }
  }

  // Preço unitário alterado → recalcula o valor total (quantidade × unitário).
  function handleUnitPriceChange(value) {
    setPriceUsd(value);
    if (Number(amountOrPrice) > 0 && Number(value) > 0) {
      setPriceTotal((Number(amountOrPrice) * Number(value)).toFixed(2));
    }
  }

  // Valor total inserido manualmente → deriva o preço unitário (total ÷ qtd).
  function handleTotalChange(value) {
    setPriceTotal(value);
    if (Number(amountOrPrice) > 0 && Number(value) > 0) {
      setPriceUsd((Number(value) / Number(amountOrPrice)).toFixed(4));
    }
  }

  useEffect(() => {
    if (edit) {
      setValue('participantName', edit.participantName);
      setValue('tickerSymbol', edit.tickerSymbol);
      setActiveSelect(edit.tickerSymbol);
      setAmountOrPrice(edit.equitiesQuantity);
      setValue('productTypeName', edit.productTypeName);
      handleGetListActive(edit.productTypeName);
      setValue('agregarAutomatico', edit.agregarAutomatico);
    }
  }, [edit]);

  async function handleGetListActive(Active) {
    setTypeActive(Active);
    if (Active === 'acao') {
      await axios
        .get(
          `${process.env.REACT_APP_API_URL}${financeRoutes.FINANCE_ALL_ACTIVES}`,
          {
            params: {
              search: 'ACAO',
            },
          }
        )
        .then((response) => {
          let actions = response.data;

          actions = actions.map((action) => {
            let newObjSelect = {
              value: action.Asset,
              label: `${action.Asset} - ${action.NomeAtivo}`,
            };
            return newObjSelect;
          });
          setValues(response.data);
          setSelectValues(actions);
        })
        .catch((error) => {});
    } else if (Active === 'FII') {
      await axios
        .get(
          `${process.env.REACT_APP_API_URL}${financeRoutes.FINANCE_ALL_ACTIVES}`,
          {
            params: {
              search: 'FII',
            },
          }
        )
        .then((response) => {
          let actions = response.data;
          actions = actions.map((action) => {
            let newObjSelect = {
              value: action.Asset,
              label: `${action.Asset} - ${action.NomeAtivo}`,
            };
            return newObjSelect;
          });
          setSelectValues(actions);
          setValues(response.data);
        })
        .catch((error) => {});
    }
    if (Active === 'rendaFixa') {
      setSelectValues([]);
    }
    if (INTERNATIONAL_TYPES.includes(Active)) {
      setSelectValues([]);
    }
  }

  // Mapeia o tipo selecionado para o `type` aceito no search (singular).
  const SEARCH_TYPE_BY_ACTIVE = {
    stock: 'stock',
    stocks: 'stock',
    reit: 'reit',
    reits: 'reit',
    etf: 'etf',
    etfs: 'etf',
  };

  // Busca assíncrona de ativos internacionais (stock/reit/etf) por ticker/nome.
  async function loadInternationalAssets(inputValue) {
    if (!inputValue) return [];
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/international/assets/search`,
        {
          params: {
            q: inputValue,
            type: SEARCH_TYPE_BY_ACTIVE[typeActive] ?? typeActive,
          },
        }
      );
      return (response.data || []).map((item) => {
        // Compatível com o retorno novo ({ticker, name}) e o antigo (string).
        const ticker = typeof item === 'string' ? item : item.ticker;
        const name = typeof item === 'string' ? '' : item.name;
        return {
          value: ticker,
          label: name ? `${ticker} - ${name}` : ticker,
        };
      });
    } catch (error) {
      return [];
    }
  }

  // Ao escolher o ativo internacional e a data da operação, busca o valor
  // unitário (close) na data. O preço permanece editável após o preenchimento.
  useEffect(() => {
    if (!isInternational || !activeSelect || !tradeDate) return;
    let isCurrent = true;
    (async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/international/assets/${activeSelect}/price`,
          { params: { date: tradeDate } }
        );
        if (isCurrent && response.data?.value != null) {
          const unit = Number(response.data.value);
          setPriceUsd(String(unit));
          const quantity = Number(amountRef.current);
          if (quantity > 0) {
            setPriceTotal((quantity * unit).toFixed(2));
          }
        }
      } catch (error) {
        if (isCurrent) {
          handleToast(true, 'Não foi possível obter o valor unitário na data');
        }
      }
    })();
    return () => {
      isCurrent = false;
    };
  }, [isInternational, activeSelect, tradeDate]);

  const returnSelectValue = (id, arr) => {
    if (id) {
      let obj = arr?.map((item) => {
        if (item?.value === id) {
          return {
            value: item.value,
            label: item.label,
          };
        }
      });
      return obj;
    } else {
      return null;
    }
  };

  function handleValidate(_data) {
    if (isInternational) {
      if (!_data.tickerSymbol) {
        return handleToast(true, 'O campo ativo é obrigatório');
      }
      if (!tradeDate) {
        return handleToast(true, 'A data da operação é obrigatória');
      }
      if (!amountOrPrice) {
        return handleToast(true, 'O campo quantidade é obrigatório');
      }
      if (!priceUsd) {
        return handleToast(true, 'O preço unitário (USD) é obrigatório');
      }
      if (!brokerOrigin) {
        return handleToast(true, 'A corretora de origem é obrigatória');
      }
      return;
    }

    if (!_data.participantName) {
      return handleToast(true, 'O campo instituição é obrigatório');
    }
    if (!_data.tickerSymbol) {
      return handleToast(true, 'O campo ativo é obrigatório');
    }
    if (!amountOrPrice) {
      if (typeActive === 'rendaFixa') {
        return handleToast(true, 'O campo valor é obrigatório');
      } else {
        return handleToast(true, 'O campo quantidade é obrigatório');
      }
    }
    if (!_data.productTypeName) {
      return handleToast(true, 'O campo tipo de ativo é obrigatório');
    } else if (
      _data.productTypeName === 'acao' ||
      _data.productTypeName === 'FII'
    ) {
      if (!activeSelect) {
        return handleToast(true, 'O campo ativo é obrigatório');
      }
    }
  }

  async function submit(data) {
    if (isInternational) {
      if (handleValidate(data)) return;

      const payload = {
        asset: String(data.tickerSymbol || '').toUpperCase(),
        trade_date: tradeDate,
        side: 'BUY',
        quantity: String(amountOrPrice),
        price_usd: String(priceUsd),
        broker_origin: String(brokerOrigin).toUpperCase(),
        price_total: priceTotal,
      };

      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/international/trades/`,
          payload
        );
        handleToast(false, 'Ativo cadastrado com sucesso');
        update();
        updateWallet();
      } catch (err) {
        console.error(err);
        handleToast(true, 'Erro ao cadastrar ativo');
      }
      return;
    }

    if (activeSelect) {
      data.tickerSymbol = activeSelect;
      const nameActive = values.find((item) => item.Asset === activeSelect);
      if (nameActive) {
        data.corporationName = nameActive.NomeAtivo;
      }
    }

    if (handleValidate(data)) return;

    data.equitiesQuantity = amountOrPrice;
    if (typeActive === 'rendaFixa') {
      data.equitiesQuantity = data.equitiesQuantity
        .replace(/\D/g, '')
        .replace(/(\d)(\d{2})$/, '$1.$2');
    }

    data.tickerSymbol = data.tickerSymbol.toUpperCase();
    data.participantName = data.participantName;
    data.active = true;

    if (edit) {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/Finance/carteira/update/${props.edit?.key}/`,
          data
        );
        handleToast(false, 'Ativo atualizado com sucesso');
        update();
        updateWallet();
      } catch (err) {
        console.error(err);
        handleToast(true, 'Erro ao atualizar ativo');
      }
    } else {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/Finance/carteira/create/`,
          data
        );
        handleToast(false, 'Ativo cadastrado com sucesso');
        update();
        updateWallet();
      } catch (err) {
        console.error(err);
        handleToast(true, 'Erro ao cadastrar ativo');
      }
    }
  }

  const selectStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? '#0176E1' : 'transparent',
      borderRadius: 8,
    }),
    container: (baseStyles) => ({
      ...baseStyles,
      boxShadow: ' 2px 2px 6px 0px #0000001A',
      borderRadius: 8,
    }),
    input: (baseStyles) => ({
      ...baseStyles,
      color: '#808080',
      fontSize: 16,
    }),
    placeholder: (base) => ({
      ...base,
    }),
    valueContainer: (base) => ({
      ...base,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 8,
      paddingBottom: 8,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#808080',
    }),
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(submit)}>
        {!edit && (
          <>
            {!isInternational && (
              <div className="form-group mb-3">
                <label className="mb-1">
                  <strong>Instituição</strong>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ex: Corretora Rico"
                  {...register('participantName')}
                />
              </div>
            )}

            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>Tipo de ativo</strong>
              </label>
              <select
                className="form-control"
                {...register('productTypeName')}
                defaultValue=""
                onChange={(e) => {
                  setActiveSelect('');
                  setValue('tickerSymbol', '');
                  setPriceUsd('');
                  setPriceTotal('');
                  handleGetListActive(e.target.value);
                }}
              >
                <option value="" disabled>
                  Selecione o tipo de ativo
                </option>
                <option value="acao">Ação</option>
                <option value="FII">FIIs</option>
                <option value="rendaFixa">Renda Fixa</option>
                <option value="stocks">Stocks</option>
                <option value="etfs">ETFs</option>
                <option value="reits">REITs</option>
                <option value="cripto">Criptomoedas</option>
              </select>
            </div>

            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>Ativo</strong>
              </label>
              {isInternational ? (
                <AsyncSelect
                  className="select"
                  cacheOptions
                  loadOptions={loadInternationalAssets}
                  onChange={(e) => {
                    const ticker = e?.value || '';
                    setActiveSelect(ticker);
                    setValue('tickerSymbol', ticker);
                  }}
                  value={
                    activeSelect
                      ? { value: activeSelect, label: activeSelect }
                      : null
                  }
                  placeholder="Busque por ticker (ex: AMZN)"
                  loadingMessage={() => 'Buscando...'}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue
                      ? 'Nenhum ativo encontrado'
                      : 'Digite para buscar'
                  }
                  styles={selectStyles}
                />
              ) : selectValues.length >= 1 && typeActive !== 'rendaFixa' ? (
                <Select
                  className="select"
                  options={selectValues}
                  onChange={(e) => setActiveSelect(e.value)}
                  value={returnSelectValue(activeSelect, selectValues)}
                  placeholder="Selecione o tipo de filtro"
                  styles={selectStyles}
                />
              ) : (
                <input
                  type="text"
                  className="form-control"
                  placeholder={isInternational ? 'ex: NVDA' : 'ex: WEGE3'}
                  {...register('tickerSymbol')}
                />
              )}
            </div>

            {isInternational && (
              <>
                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>Data da operação</strong>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={tradeDate}
                    onChange={(e) => setTradeDate(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>Quantidade</strong>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    placeholder="ex: 10"
                    value={amountOrPrice}
                    onChange={(e) => handleQuantityChange(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>Preço unitário (USD)</strong>
                  </label>
                  <input
                    type="number"
                    step="0.0001"
                    className="form-control"
                    placeholder="ex: 150.50"
                    value={priceUsd}
                    onChange={(e) => handleUnitPriceChange(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>Valor total (USD)</strong>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    placeholder="auto: quantidade × preço"
                    value={priceTotal}
                    onChange={(e) => handleTotalChange(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="mb-1">
                    <strong>Corretora de origem</strong>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ex: AVENUE"
                    value={brokerOrigin}
                    onChange={(e) => setBrokerOrigin(e.target.value)}
                  />
                </div>
              </>
            )}
          </>
        )}

        {!isInternational && (
          <div className="form-group mb-3">
            <label className="mb-1">
              <strong>
                {typeActive === 'rendaFixa' ? 'Valor investido' : 'Quantidade'}
              </strong>
            </label>
            {typeActive === 'rendaFixa' ? (
              <Input
                mask="currency"
                className="form-control"
                placeholder="ex: 10"
                onChange={(e) => setAmountOrPrice(e.target.value)}
                value={amountOrPrice}
              />
            ) : (
              <input
                type="number"
                step="0.00000001"
                className="form-control"
                placeholder="ex: 10"
                onChange={(e) => setAmountOrPrice(e.target.value)}
                value={amountOrPrice}
              />
            )}
          </div>
        )}

        <div className="form-group mb-3 checkbox">
          <input
            {...register('agregarAutomatico')}
            id="agregarAutomatico"
            type="checkbox"
            defaultChecked={user.automatico}
          />
          <label className="mb-1" htmlFor="agregarAutomatico">
            <strong>Adicionar a carteira automática</strong>
          </label>
        </div>

        <div className="text-center mt-4 row-content">
          <button
            className="btn btn-danger btn-block"
            type="button"
            onClick={() => setCancel(false)}
          >
            Cancelar
          </button>
          <br />
          <button type="submit" className="btn btn-primary btn-block">
            {edit ? 'Editar' : 'Cadastrar'}
          </button>
        </div>
      </form>
    </Container>
  );
}
